import { render } from "./HomeSpellingRule.vue?vue&type=template&id=de2347a2&scoped=true&ts=true"
import script from "./HomeSpellingRule.vue?vue&type=script&lang=ts"
export * from "./HomeSpellingRule.vue?vue&type=script&lang=ts"

import "./HomeSpellingRule.vue?vue&type=style&index=0&id=de2347a2&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de2347a2"]])

export default __exports__